/**
 * Real Estate Search Component JavaScript
 * Handles tab switching and form interactions
 */

class RealEstateSearch {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('.t4s-re-search-form');
    this.searchInput = container.querySelector('.t4s-re-search-input');
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.setDefaultTab();
  }
  
  bindEvents() {
    
    // Form submission
    this.form.addEventListener('submit', (e) => {
      this.handleFormSubmit(e);
    });
    
    // Enhanced UX: Clear button for search input
    this.addClearButton();
    
    // Enhanced UX: Keyboard navigation
    this.addKeyboardNavigation();
  }
  
  setDefaultTab() {
    const activeTab = this.container.querySelector('.t4s-re-tab.active');
    if (activeTab) {
      this.switchTab(activeTab);
    }
  }
  
  updatePlaceholders(tabType) {
    const placeholders = {
      rent: 'Search for rentals...',
      buy: 'Search properties for sale...',
      new_projects: 'Search new developments...',
      commercial: 'Search commercial properties...'
    };
    
    if (this.searchInput && placeholders[tabType]) {
      this.searchInput.setAttribute('placeholder', 
        this.searchInput.getAttribute('placeholder') || placeholders[tabType]
      );
    }
  }
  
  handleFormSubmit(e) {
    e.preventDefault();
    
    const formData = new FormData(this.form);
    const searchQuery = this.buildSearchQuery(formData);
    
    // Redirect to search page with constructed query
    const searchUrl = `${this.form.action}?${searchQuery}`;

    if(!searchQuery) {
      // If no search query, redirect to all collections
      window.location.href = window.Shopify.routes.root + 'collections/all';
      return;
    }
    window.location.href = searchUrl;

    
  }
  
  buildSearchQuery(formData) {
    const params = new URLSearchParams();
    
    // Build the main search query
    let searchTerms = [];
    
    // Add location search
    const location = formData.get('q');
    if (location && location.trim()) {
      searchTerms.push(location.trim());
    }
    
    // Combine all search terms
    if (searchTerms.length > 0) {
      params.append('q', searchTerms.join(' AND '));
    }
    
    return params.toString();
  }
  
  addClearButton() {
    const inputContainer = this.searchInput.parentElement;
    const clearButton = document.createElement('button');
    clearButton.type = 'button';
    clearButton.className = 't4s-re-clear-btn';
    clearButton.innerHTML = '×';
    clearButton.style.cssText = `
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      font-size: 18px;
      color: #999;
      cursor: pointer;
      padding: 0;
      width: 20px;
      height: 20px;
      display: none;
      align-items: center;
      justify-content: center;
    `;
    
    inputContainer.style.position = 'relative';
    inputContainer.appendChild(clearButton);
    
    // Show/hide clear button
    this.searchInput.addEventListener('input', () => {
      clearButton.style.display = this.searchInput.value ? 'flex' : 'none';
    });
    
    // Clear functionality
    clearButton.addEventListener('click', () => {
      this.searchInput.value = '';
      clearButton.style.display = 'none';
      this.searchInput.focus();
    });
  }
  
  addKeyboardNavigation() {
    // Tab navigation with arrow keys
    this.container.addEventListener('keydown', (e) => {
      if (e.target.classList.contains('t4s-re-tab')) {
        const currentIndex = Array.from(this.tabs).indexOf(e.target);
        let newIndex;
        
        switch (e.key) {
          case 'ArrowLeft':
            newIndex = currentIndex > 0 ? currentIndex - 1 : this.tabs.length - 1;
            break;
          case 'ArrowRight':
            newIndex = currentIndex < this.tabs.length - 1 ? currentIndex + 1 : 0;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            this.switchTab(e.target);
            return;
          default:
            return;
        }
        
        if (newIndex !== undefined) {
          e.preventDefault();
          this.tabs[newIndex].focus();
          this.switchTab(this.tabs[newIndex]);
        }
      }
    });
    
    // Form submission with Enter key
    this.searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.form.dispatchEvent(new Event('submit'));
      }
    });
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const searchContainers = document.querySelectorAll('.t4s-real-estate-search');
  searchContainers.forEach(container => {
    new RealEstateSearch(container);
  });
});

// Initialize for any dynamically added search components
window.initRealEstateSearch = (container) => {
  new RealEstateSearch(container);
};